import { get, toLower } from "lodash"
import { createSelector } from "reselect"
import { getDatasetEntitlementsEnabled } from "modules/account-root/selectors"
import { isAllAccessTeam } from "helpers/permissions/teams"
import { getRole } from "helpers/permissions/roles"
import { computeTeamTabs } from "helpers/permissions/tabs"
import { getPath, getRoute } from "selectors/urls"

export const getTeamAlias = (_, props) => props.params.teamAlias
export const getTeamId = (_, props) => get(props, "teamTokens.team.id")
export const getTeamRole = (_, props) => toLower(get(props, "teamTokens.team.role"))
export const getTeamTokens = (_, props) => get(props, "teamTokens.team.tokens")
export const getTokens = (_, props) => get(props, "tokens.tokens")

const getIsAllAccessTeam = createSelector(
  [getTeamAlias],
  (teamAlias) => isAllAccessTeam(teamAlias),
)

export const getTabs = createSelector(
  [getRoute, getPath, getDatasetEntitlementsEnabled, getRole, getTeamRole, getIsAllAccessTeam],
  computeTeamTabs,
)
